import { useEffect, useRef } from 'react';

import { filterNullishValuesFromObject } from '@pkg/utils';

import { type TimeoutCallback, type TimeoutHookOptions } from './types';

const DEFAULT_OPTIONS: Required<TimeoutHookOptions> = {
    duration: 0,
    playing: true,
};

// TODO: This is copied from our eventual `react-hooks` package:
// https://github.com/beefchimi/react-hooks
export function useTimeout(callback: TimeoutCallback, options?: TimeoutHookOptions): void {
    const { duration, playing } = {
        ...DEFAULT_OPTIONS,
        ...filterNullishValuesFromObject(options),
    };

    const callbackRef = useRef<TimeoutCallback>();
    const timeoutRef = useRef<number>();

    function handleCallback() {
        callbackRef.current?.(Date.now());
    }

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (playing) {
            timeoutRef.current = window.setTimeout(handleCallback, duration);
        }

        return () => clearTimeout(timeoutRef.current);
    }, [duration, playing]);
}
